import { useEffect } from 'react'
import { useState } from 'react'
import { createPortal } from 'react-dom'

export const NAVBAR_PORTAL_ID = 'navbar-portal'

export default function NavbarPortal({ children }) {
	const [element, setElement] = useState<HTMLElement | null>(null)

	useEffect(() => {
		if (typeof window !== 'undefined') {
			setElement(document.getElementById(NAVBAR_PORTAL_ID))
		}
	}, [])

	return element ? createPortal(children, element) : null
}
